// ARQUIVO GERADO — não edite à mão.
// Rode `npm run icons:generate` após adicionar/remover ícones no código.
// Mantém o bundle inicial enxuto: só os ícones usados entram no build.

import {
  Activity,
  AlertCircle,
  AlertTriangle,
  Apple,
  ArrowLeft,
  ArrowRight,
  ArrowUpRight,
  Award,
  Baby,
  Badge,
  BadgeCheck,
  Ban,
  BarChart2,
  Bell,
  BellRing,
  BookOpen,
  Bookmark,
  Briefcase,
  Calendar,
  CalendarDays,
  Camera,
  Check,
  CheckCircle,
  CheckCircle2,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  Chrome,
  CircleUserRound,
  Clock,
  Code,
  Coffee,
  Cookie,
  Copy,
  CreditCard,
  Crown,
  Database,
  Diamond,
  DollarSign,
  Download,
  Edit,
  Edit2,
  ExternalLink,
  Eye,
  EyeOff,
  Facebook,
  File,
  FileBarChart,
  FileSearch,
  FileText,
  Filter,
  Flag,
  Gem,
  Gift,
  GitCompare,
  Grid3X3,
  Grid3x3,
  HardDrive,
  Headphones,
  Heart,
  HeartCrack,
  HeartHandshake,
  HeartOff,
  HelpCircle,
  History,
  Home,
  Image,
  ImageOff,
  ImagePlus,
  Images,
  Inbox,
  Infinity as InfinityIcon,
  Info,
  Key,
  LayoutDashboard,
  Lightbulb,
  LineChart,
  List,
  ListOrdered,
  Loader,
  Loader2,
  Lock,
  LogIn,
  LogOut,
  Mail,
  MailCheck,
  MailX,
  MapPin,
  Maximize2,
  Medal,
  MessageCircle,
  MessageSquare,
  MessageSquareX,
  MessagesSquare,
  Minus,
  Moon,
  MoreHorizontal,
  MoreVertical,
  Package,
  Paperclip,
  PenLine,
  Pencil,
  Percent,
  Plane,
  Play,
  Plus,
  QrCode,
  Receipt,
  RefreshCw,
  Repeat,
  RotateCcw,
  Rss,
  Save,
  Scale,
  ScrollText,
  Search,
  Send,
  Server,
  Settings,
  Shield,
  ShieldAlert,
  ShieldCheck,
  ShieldOff,
  ShoppingCart,
  SlidersHorizontal,
  Smartphone,
  Sparkles,
  Star,
  StarHalf,
  Sun,
  Tag,
  Target,
  Theater,
  ThumbsUp,
  Ticket,
  Tickets,
  Timer,
  Trash2,
  TrendingDown,
  TrendingUp,
  Trophy,
  Truck,
  Undo2,
  Upload,
  User,
  UserCheck,
  UserCircle,
  UserCog,
  UserMinus,
  UserPlus,
  UserX,
  Users,
  UtensilsCrossed,
  Wallet,
  Webhook,
  WifiOff,
  X,
  XCircle,
  Zap,
  ZoomIn,
} from "lucide-react";

const lucideIcons = {
  Activity,
  AlertCircle,
  AlertTriangle,
  Apple,
  ArrowLeft,
  ArrowRight,
  ArrowUpRight,
  Award,
  Baby,
  Badge,
  BadgeCheck,
  Ban,
  BarChart2,
  Bell,
  BellRing,
  BookOpen,
  Bookmark,
  Briefcase,
  Calendar,
  CalendarDays,
  Camera,
  Check,
  CheckCircle,
  CheckCircle2,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  Chrome,
  CircleUserRound,
  Clock,
  Code,
  Coffee,
  Cookie,
  Copy,
  CreditCard,
  Crown,
  Database,
  Diamond,
  DollarSign,
  Download,
  Edit,
  Edit2,
  ExternalLink,
  Eye,
  EyeOff,
  Facebook,
  File,
  FileBarChart,
  FileSearch,
  FileText,
  Filter,
  Flag,
  Gem,
  Gift,
  GitCompare,
  Grid3X3,
  Grid3x3,
  HardDrive,
  Headphones,
  Heart,
  HeartCrack,
  HeartHandshake,
  HeartOff,
  HelpCircle,
  History,
  Home,
  Image,
  ImageOff,
  ImagePlus,
  Images,
  Inbox,
  Infinity: InfinityIcon,
  Info,
  Key,
  LayoutDashboard,
  Lightbulb,
  LineChart,
  List,
  ListOrdered,
  Loader,
  Loader2,
  Lock,
  LogIn,
  LogOut,
  Mail,
  MailCheck,
  MailX,
  MapPin,
  Maximize2,
  Medal,
  MessageCircle,
  MessageSquare,
  MessageSquareX,
  MessagesSquare,
  Minus,
  Moon,
  MoreHorizontal,
  MoreVertical,
  Package,
  Paperclip,
  PenLine,
  Pencil,
  Percent,
  Plane,
  Play,
  Plus,
  QrCode,
  Receipt,
  RefreshCw,
  Repeat,
  RotateCcw,
  Rss,
  Save,
  Scale,
  ScrollText,
  Search,
  Send,
  Server,
  Settings,
  Shield,
  ShieldAlert,
  ShieldCheck,
  ShieldOff,
  ShoppingCart,
  SlidersHorizontal,
  Smartphone,
  Sparkles,
  Star,
  StarHalf,
  Sun,
  Tag,
  Target,
  Theater,
  ThumbsUp,
  Ticket,
  Tickets,
  Timer,
  Trash2,
  TrendingDown,
  TrendingUp,
  Trophy,
  Truck,
  Undo2,
  Upload,
  User,
  UserCheck,
  UserCircle,
  UserCog,
  UserMinus,
  UserPlus,
  UserX,
  Users,
  UtensilsCrossed,
  Wallet,
  Webhook,
  WifiOff,
  X,
  XCircle,
  Zap,
  ZoomIn,
};

export default lucideIcons;
